import { render, staticRenderFns } from "./ImageMetadataModal.vue?vue&type=template&id=00877c7e&scoped=true&"
import script from "./ImageMetadataModal.vue?vue&type=script&lang=js&"
export * from "./ImageMetadataModal.vue?vue&type=script&lang=js&"
import style0 from "./ImageMetadataModal.vue?vue&type=style&index=0&id=00877c7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00877c7e",
  null
  
)

export default component.exports